<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              สแกนแลกแต้ม
            </span>
          </h3>
          <div class="card-toolbar">
            <b-button
              variant="primary"
              class="float-right"
              style="padding-top: 6px; padding-bottom: 6px"
              v-on:click.prevent="openCreateModal()"
            >
              {{ $t("PAGE.DEFAULT.TABLE.NEW") }}
            </b-button>
          </div>
        </div>
        <div class="card-body pt-0 pb-3">
          <div class="col-lg-6 p-0 mb-4">
            <b-form-group class="mb-0">
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
                  type="search"
                  id="filterInput"
                  debounce="300"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">{{
                    $t("PAGE.DEFAULT.TABLE.CLEAR")
                  }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="tab-content">
            <div class="table-responsive">
              <b-table
                id="campaign-qr-table"
                :striped="false"
                :items="items"
                :fields="fields"
                :busy="isBusy"
                :borderless="true"
                head-variant="light"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner small class="align-middle mr-2"></b-spinner>
                  </div>
                </template>

                <!-- ลำดับ -->
                <template #cell(index)="data">
                  <div class="text-right">
                    {{
                      (pagination.page - 1) * pagination.perPage +
                      data.index +
                      1
                    }}
                  </div>
                </template>

                <template #cell(point)="data">
                  <span>{{
                    Number(data.item.point).toLocaleString("th-TH")
                  }}</span>
                </template>

                <!-- ช่วงเวลาใช้งาน -->
                <template #cell(period)="data">
                  <span class="text-nowrap">
                    {{ formatDateTime(data.item.start_at) }} -
                    {{ formatDateTime(data.item.end_at) }}
                  </span>
                </template>

                <template #cell(scan_count)="data">
                  <span>{{
                    Number(
                      (data.item.__meta__ && data.item.__meta__.scan_count) || 0
                    ).toLocaleString("th-TH")
                  }}</span>
                </template>

                <!-- สถานะ -->
                <template #cell(status)="data">
                  <b-form-checkbox
                    switch
                    :checked="data.item.status_id === STATUS_ACTIVE"
                    :disabled="statusUpdatingId === data.item.id"
                    @change="toggleStatus(data.item, $event)"
                  ></b-form-checkbox>
                </template>

                <!-- จัดการ -->
                <template #cell(action)="data">
                  <a
                    href="javascript:"
                    @click.prevent="goToManage(data.item)"
                    class="btn btn-icon btn-light btn-sm"
                    :aria-label="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-success">
                      <inline-svg
                        src="media/svg/icons/General/Edit.svg"
                      ></inline-svg>
                    </span>
                  </a>
                </template>

                <!-- ดาวน์โหลด -->
                <template #cell(download)="data">
                  <a
                    href="javascript:"
                    @click.prevent="downloadQr(data.item)"
                    class="btn btn-icon btn-light btn-sm"
                    :aria-label="
                      $t('PAGE.DEFAULT.TABLE.FIELDS.DOWNLOAD.DOWNLOAD')
                    "
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg
                        src="media/svg/icons/Files/Download.svg"
                      ></inline-svg>
                    </span>
                  </a>
                </template>
              </b-table>

              <p class="text-center pt-3" v-if="!isBusy && items.length < 1">
                {{
                  loadError
                    ? "โหลดข้อมูลไม่สำเร็จ"
                    : $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND")
                }}
              </p>
            </div>

            <!-- Pagination Row -->
            <div
              class="row justify-content-between align-items-center mt-3"
              v-if="total > 0"
            >
              <div class="col-auto">
                <b-form-group
                  id="per-page-group"
                  :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
                  label-for="perPageSelect"
                  label-cols="auto"
                  label-align-sm="left"
                  label-size="sm"
                  class="mb-0 d-flex align-items-center"
                >
                  <b-form-select
                    v-model="pagination.perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="paginationOptions"
                    style="width: 80px"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-auto">
                <b-pagination
                  v-model="pagination.page"
                  :total-rows="total"
                  :per-page="pagination.perPage"
                  align="right"
                  class="mb-0"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal เพิ่มสแกนแลกแต้ม (รูปแบบเดียวกับแท็บของรางวัล) -->
    <b-modal
      id="modal-qr-redeem"
      ref="modal-qr-redeem"
      title="เพิ่มสแกนแลกแต้ม"
      :ok-title="$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
      :cancel-title="$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
      :ok-disabled="isSubmitting"
      @ok="handleModalOk"
      @hidden="resetModalForm"
      size="lg"
    >
      <form ref="form" @submit.stop.prevent="submitModal">
        <b-row id="mqr-name" class="mb-5">
          <b-col sm="3">
            <label>
              <h5>{{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}</h5>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input
              id="qr-name-input"
              name="qr-name-input"
              v-model="$v.modalForm.name.$model"
              :state="validateModalState('name')"
              aria-describedby="name-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="name-live-feedback">
              <span v-if="!$v.modalForm.name.required" class="error">
                {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
              </span>
              <span v-else-if="!$v.modalForm.name.maxLength" class="error">
                ชื่อต้องไม่เกิน {{ MAX_NAME_LENGTH }} ตัวอักษร
              </span>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row id="mqr-point" class="mb-5">
          <b-col sm="3">
            <label>
              <h5>{{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.POINT") }}</h5>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input
              id="qr-point-input"
              name="qr-point-input"
              type="number"
              min="1"
              step="1"
              @wheel="$event.target.blur()"
              v-model.number="$v.modalForm.point.$model"
              :state="validateModalState('point')"
              aria-describedby="point-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="point-live-feedback">
              <span v-if="!$v.modalForm.point.required" class="error">
                {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
              </span>
              <span v-else class="error">
                จำนวนแต้มต้องเป็นจำนวนเต็ม 1 -
                {{ MAX_POINT.toLocaleString("th-TH") }}
              </span>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row id="mqr-start" class="mb-5">
          <b-col sm="3">
            <label>
              <h5>วันเริ่มใช้งาน</h5>
            </label>
          </b-col>
          <b-col sm="9">
            <date-picker
              id="qr-start-datepicker"
              v-model="$v.modalForm.start_at.$model"
              :config="options"
              autocomplete="off"
              placeholder="ไม่ระบุ = ใช้ได้ตั้งแต่เริ่มแคมเปญ"
            ></date-picker>
          </b-col>
        </b-row>

        <b-row id="mqr-expire" class="mb-5">
          <b-col sm="3">
            <label>
              <h5>วันหมดอายุ</h5>
            </label>
          </b-col>
          <b-col sm="9">
            <date-picker
              id="qr-expire-datepicker"
              v-model="$v.modalForm.end_at.$model"
              :config="options"
              autocomplete="off"
              placeholder="ไม่ระบุ = ใช้ได้จนจบแคมเปญ"
            ></date-picker>
            <span
              v-if="
                $v.modalForm.end_at.$dirty && !$v.modalForm.end_at.endAfterStart
              "
              class="error text-danger d-block mt-1"
            >
              วันหมดอายุต้องอยู่หลังวันเริ่มใช้งาน
            </span>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<style>
.actionField {
  min-width: 100px;
  width: 100px;
  max-width: 100px;
}
</style>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxValue,
  maxLength,
  integer
} from "vuelidate/lib/validators";
import datePicker from "vue-bootstrap-datetimepicker";
import Swal from "sweetalert2";
import ApiService from "@/core/services/api.service";
import {
  STATUS_ACTIVE,
  STATUS_INACTIVE,
  MAX_POINT,
  MAX_NAME_LENGTH,
  PICKER_FORMAT,
  buildQrPayload,
  downloadQrImage,
  toApiDate,
  formatDateTime,
  endAfterStart,
  manageRoute
} from "./qrRedeem.helper";

function emptyForm() {
  return { name: "", point: null, start_at: "", end_at: "" };
}

export default {
  name: "CampaignQrSetting",
  mixins: [validationMixin],
  components: {
    datePicker
  },
  props: {
    campaignId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      STATUS_ACTIVE,
      MAX_POINT,
      MAX_NAME_LENGTH,
      options: {
        useCurrent: false,
        locale: "th",
        format: PICKER_FORMAT,
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      modalForm: emptyForm(),
      fields: [
        {
          key: "index",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          sortable: false
        },
        {
          key: "name",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.NAME")}`,
          sortable: false
        },
        { key: "point", label: "แต้มที่ได้รับ", sortable: false },
        { key: "period", label: "ช่วงเวลาใช้งาน", sortable: false },
        { key: "scan_count", label: "จำนวนสแกน", sortable: false },
        { key: "status", label: "สถานะ", sortable: false },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          tdClass: "actionField"
        },
        {
          key: "download",
          label: "ดาวน์โหลด",
          sortable: false,
          tdClass: "actionField"
        }
      ],
      isBusy: false,
      isSubmitting: false,
      loadError: false,
      statusUpdatingId: null,
      filter: "",
      pagination: {
        page: 1,
        perPage: 10
      },
      paginationOptions: [5, 10, 20, 50],
      items: [],
      total: 0
    };
  },
  validations: {
    modalForm: {
      name: { required, maxLength: maxLength(MAX_NAME_LENGTH) },
      point: {
        required,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(MAX_POINT)
      },
      start_at: {},
      end_at: { endAfterStart }
    }
  },
  watch: {
    filter() {
      this.reloadFirstPage();
    },
    "pagination.perPage"() {
      this.reloadFirstPage();
    },
    "pagination.page"() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    formatDateTime,
    reloadFirstPage() {
      if (this.pagination.page === 1) {
        this.fetchData();
      } else {
        // watcher ของ page จะ fetch ให้เอง
        this.pagination.page = 1;
      }
    },
    async fetchData() {
      this.isBusy = true;
      this.loadError = false;
      try {
        ApiService.setHeader();
        const { data } = await ApiService.getParams(
          `campaign/${this.campaignId}/qr_point/pagination`,
          {
            params: {
              page: this.pagination.page,
              perPage: this.pagination.perPage,
              q: (this.filter || "").trim()
            }
          }
        );
        if (data.status === "success" && data.data) {
          this.items = data.data.data || [];
          this.total = Number(data.data.total) || 0;
        } else {
          this.loadError = true;
          this.items = [];
          this.total = 0;
        }
      } catch (e) {
        this.loadError = true;
        this.items = [];
        this.total = 0;
      } finally {
        this.isBusy = false;
      }
    },
    goToManage(item) {
      this.$router.push(manageRoute(this.$route, this.campaignId, item.id));
    },
    openCreateModal() {
      this.resetModalForm();
      this.$bvModal.show("modal-qr-redeem");
    },
    validateModalState(name) {
      const { $dirty, $error } = this.$v.modalForm[name];
      return $dirty ? !$error : null;
    },
    resetModalForm() {
      this.modalForm = emptyForm();
      this.$v.modalForm.$reset();
    },
    handleModalOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.submitModal();
    },
    async submitModal() {
      this.$v.modalForm.$touch();
      if (this.$v.modalForm.$anyError || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      try {
        ApiService.setHeader();
        const { data } = await ApiService.post(
          `campaign/${this.campaignId}/qr_point`,
          {
            name: this.modalForm.name.trim(),
            point: Number(this.modalForm.point),
            start_at: toApiDate(this.modalForm.start_at),
            end_at: toApiDate(this.modalForm.end_at)
          }
        );
        if (data.status !== "success") {
          throw new Error(data.error);
        }
        this.$bvModal.hide("modal-qr-redeem");
        Swal.fire({
          icon: "success",
          title: "เพิ่มสแกนแลกแต้มเรียบร้อย",
          timer: 1500,
          showConfirmButton: false
        });
        this.reloadFirstPage();
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "เพิ่มสแกนแลกแต้มไม่สำเร็จ",
          text: "กรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง"
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async toggleStatus(item, checked) {
      const previous = item.status_id;
      const statusId = checked ? STATUS_ACTIVE : STATUS_INACTIVE;
      item.status_id = statusId;
      this.statusUpdatingId = item.id;
      try {
        ApiService.setHeader();
        const { data } = await ApiService.put(
          `campaign/${this.campaignId}/qr_point/${item.id}/status`,
          { status_id: statusId }
        );
        if (data.status !== "success") {
          throw new Error(data.error);
        }
      } catch (e) {
        item.status_id = previous;
        Swal.fire({ icon: "error", title: "เปลี่ยนสถานะไม่สำเร็จ" });
      } finally {
        this.statusUpdatingId = null;
      }
    },
    async downloadQr(item) {
      const payload = buildQrPayload(item.code);
      if (!payload) {
        Swal.fire({ icon: "error", title: "ไม่พบรหัส QR" });
        return;
      }
      try {
        await downloadQrImage(payload, `qr-redeem-${item.id}`);
      } catch (e) {
        Swal.fire({ icon: "error", title: "สร้าง QR Code ไม่สำเร็จ" });
      }
    }
  }
};
</script>
